var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"design_box_out"},[_c('div',{staticClass:"company-desc design_box"},[_c('div',[_c('img',{attrs:{"src":_vm.property.pic?_vm.property.pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png',"alt":""}})]),_vm._v("\n      "+_vm._s(_vm.property.body)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }